import { FC } from 'react';
import { Card } from '../../ui/Card';
import { Button } from '../../ui/Button';
import { Badge } from '../../ui/Badge';
import { Input } from '../../ui/Input';
import { useAuth } from '../../../context/AuthContext';

export const ProfileSettingsTab: FC = () => {
  const { user } = useAuth();

  return (
    <div className="space-y-6">
      {/* Informações da Operação / Tenant Gerenciado */}
      <Card id="tenant-management">
        <Card.Header
          title={
            <div>
              <h3 className="text-sm font-semibold text-content-main">
                Organização e Tenant Gerenciado
              </h3>
              <p className="text-xs text-content-muted">
                Ambiente de dados e isolamento da operação atual
              </p>
            </div>
          }
        />
        <Card.Body className="space-y-4">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
            <Input
              label="Nome do Tenant"
              value={user?.tenant_name || 'Operação Padrão'}
              disabled
              helperText="Identificador da empresa/operação ativa"
            />
            <Input
              label="Slug do Tenant"
              value={user?.tenant_slug || 'default'}
              disabled
              helperText="Prefixo do subdomínio e rotas públicas"
            />
            <Input
              label="ID do Tenant"
              value={user?.tenant_id || '-'}
              disabled
              helperText="Identificador universal da partição"
            />
          </div>
        </Card.Body>
      </Card>

      {/* Dados Pessoais e Conta */}
      <Card id="profile-details">
        <Card.Header
          title={
            <div>
              <h3 className="text-sm font-semibold text-content-main">
                Perfil do Usuário
              </h3>
              <p className="text-xs text-content-muted">
                Informações da conta e credenciais de acesso ao painel
              </p>
            </div>
          }
        />
        <Card.Body className="space-y-4">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <Input
              label="Nome Completo"
              value={user?.name || 'Administrador'}
              disabled
              helperText="Identificador do usuário no sistema"
            />
            <Input
              label="E-mail de Acesso"
              value={user?.email || 'admin@trafficforge.local'}
              disabled
              helperText="E-mail principal para login e notificações"
            />
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <Input
              label="Nível de Acesso (Função)"
              value={
                user?.role === 'admin'
                  ? 'Administrador'
                  : user?.role || 'Operador'
              }
              disabled
            />
            <Input label="ID do Usuário" value={user?.id || '-'} disabled />
          </div>
        </Card.Body>
      </Card>

      {/* Segurança e Credenciais (TODO) */}
      <Card id="profile-security">
        <Card.Header
          title={
            <div>
              <h3 className="text-sm font-semibold text-content-main">
                Segurança e Acesso
              </h3>
              <p className="text-xs text-content-muted">
                Gerenciamento de senha e validação de e-mail
              </p>
            </div>
          }
          action={
            <Badge variant="neutral" className="text-micro">
              Em breve
            </Badge>
          }
        />
        <Card.Body className="space-y-4">
          <div className="space-y-3 rounded-xl border border-surface-border bg-surface-subtle p-4">
            <div className="flex flex-col justify-between gap-3 sm:flex-row sm:items-center">
              <div>
                <span className="text-xs font-semibold text-content-main">
                  Alteração e Recuperação de Senha
                </span>
                <p className="text-xs text-content-muted">
                  Defina uma nova senha de segurança ou solicite um link de
                  redefinição por e-mail.
                </p>
              </div>
              {/* TODO: Integrar com endpoint /api/auth/reset-password e formulário de troca de senha */}
              <Button variant="secondary" size="sm" disabled>
                Redefinir Senha
              </Button>
            </div>
          </div>

          <div className="space-y-3 rounded-xl border border-surface-border bg-surface-subtle p-4">
            <div className="flex flex-col justify-between gap-3 sm:flex-row sm:items-center">
              <div>
                <span className="text-xs font-semibold text-content-main">
                  Validação e Alteração de E-mail
                </span>
                <p className="text-xs text-content-muted">
                  Confirmação de titularidade da caixa postal e alteração do
                  endereço corporativo.
                </p>
              </div>
              {/* TODO: Integrar com fluxo de envio de token de confirmação de e-mail */}
              <Button variant="secondary" size="sm" disabled>
                Validar E-mail
              </Button>
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};
